import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import type { EventInput, EventClickArg } from "@fullcalendar/core";

export function MonthCalendar({
  events,
  onEventClick,
  initialView = "dayGridMonth",
}: {
  events: EventInput[];
  onEventClick: (reservationId: number) => void;
  initialView?: "dayGridMonth" | "timeGridWeek" | "listWeek";
}) {
  return (
    <FullCalendar
      plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
      initialView={initialView}
      headerToolbar={{
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,listWeek",
      }}
      buttonText={{ today: "今日", month: "月", week: "週", list: "一覧" }}
      locale="ja"
      height="auto"
      events={events}
      eventClick={(arg: EventClickArg) => {
        const id = Number(arg.event.id);
        if (!Number.isNaN(id)) onEventClick(id);
      }}
      eventDisplay="block"
      dayMaxEvents={3}
      moreLinkText={(n) => `他${n}件`}
      noEventsText="予定はありません"
    />
  );
}
